import { formatISO } from 'date-fns'

import connectifService from '../utils/connectifService'
import type {
  ConnectifProduct,
  ConnectifPaymentMethod,
  ConnectifCart,
  ConnectifSendOptions,
  ConnectifPurchase,
} from '../entities'

type dataParams = {
  id: string
  name: string
  slug: string
  description?: string
  media?:
    | {
        url: string
      }
    | {
        url: string
      }[]
  province: {
    slug: string
  }
  productPrice: number
}

type dataParamsCart = dataParams & {
  cartId: string
  paymentMethod: ConnectifPaymentMethod
}

const getUrl = (params: dataParams) => {
  if (params.media) {
    if (Array.isArray(params.media)) {
      return params.media[0].url
    } else {
      return params.media.url
    }
  }
}

const processPrice = (price: number) => {
  return price / 100
}

const sendConnectifPage = () => {
  if (import.meta.client) {
    connectifService.send({
      events: [{ type: 'page-visit' }],
    })
  }
}

const sendConnectifPageProduct = (params: dataParams) => {
  if (import.meta.client) {
    const connectifProduct: ConnectifProduct = {
      name: params.name,
      productDetailUrl: routes().cottageDetail(
        {
          slug: params.slug,
          province: params.province.slug,
        },
        true,
      ),
      productId: params.id,
      unitPrice: processPrice(params.productPrice),
      description: params.description
        ? cleanHTMLTags(params.description)
        : undefined,
      imageUrl: params.media ? getUrl(params) : undefined,
    }

    connectifService.send({
      events: [
        { type: 'product-visited', product: connectifProduct },
        { type: 'page-visit' },
      ],
    })
  }
}

const sendConnectifPageProductCart = (params: dataParamsCart) => {
  if (import.meta.client) {
    const connectifProduct: ConnectifProduct = {
      name: params.name,
      productDetailUrl: routes().cottageDetail(
        {
          slug: params.slug,
          province: params.province.slug,
        },
        true,
      ),
      productId: params.id,
      unitPrice: processPrice(params.productPrice),
      description: params.description
        ? cleanHTMLTags(params.description)
        : undefined,
      imageUrl: params.media ? getUrl(params) : undefined,
    }

    const cart: ConnectifCart = {
      cartId: params.cartId,
      totalQuantity: 1,
      totalPrice: processPrice(params.productPrice),
      paymentMethod: params.paymentMethod,
      products: [
        {
          name: params.name,
          productDetailUrl: routes().cottageDetail(
            {
              slug: params.slug,
              province: params.province.slug,
            },
            true,
          ),
          productId: params.id,
          unitPrice: processPrice(params.productPrice),
          description: params.description
            ? cleanHTMLTags(params.description)
            : undefined,
          imageUrl: params.media ? getUrl(params) : undefined,
          quantity: 1,
          price: processPrice(params.productPrice),
        },
      ],
    }

    connectifService.send({
      events: [
        { type: 'product-visited', product: connectifProduct },
        { type: 'page-visit' },
      ],

      options: {
        cart: cart,
      },
    })
  }
}

const sendConnectifPurchase = (
  params: dataParamsCart,
  options?: ConnectifSendOptions,
) => {
  if (import.meta.client) {
    const purchase: ConnectifPurchase = {
      cartId: params.cartId,
      totalQuantity: 1,
      totalPrice: processPrice(params.productPrice),
      paymentMethod: params.paymentMethod,
      products: [
        {
          name: params.name,
          productDetailUrl: routes().cottageDetail(
            {
              slug: params.slug,
              province: params.province.slug,
            },
            true,
          ),
          productId: params.id,
          unitPrice: processPrice(params.productPrice),
          description: params.description
            ? cleanHTMLTags(params.description)
            : undefined,
          imageUrl: params.media ? getUrl(params) : undefined,
          quantity: 1,
          price: processPrice(params.productPrice),
        },
      ],
      purchaseId: new Date().getTime().toString(),
      purchaseDate: formatISO(new Date()),
    }

    if (options) {
      connectifService.send({
        events: [{ type: 'purchase', purchase }],
        options,
      })
    } else {
      connectifService.send({
        events: [{ type: 'purchase', purchase }],
      })
    }
  }
}

export {
  sendConnectifPage,
  sendConnectifPageProduct,
  sendConnectifPageProductCart,
  sendConnectifPurchase,
}
